export enum EmailTemplate {
  ADMISSION_GROUP_RESERVATION_CREATED_STAFF = 'ADMISSION_GROUP_RESERVATION_CREATED_STAFF',
  ADMISSION_GROUP_RESERVATION_REQUEST_CREATED_STAFF = 'ADMISSION_GROUP_RESERVATION_REQUEST_CREATED_STAFF',
  ADMISSION_GROUP_RESERVATION_CANCELLED_STAFF = 'ADMISSION_GROUP_RESERVATION_CANCELLED_STAFF',
  ORDER_PAYMENT_LINK_CONSUMER = 'ORDER_PAYMENT_LINK_CONSUMER',
  CONFIRMATION_REQUEST_COMPLETED_STAFF = 'CONFIRMATION_REQUEST_COMPLETED_STAFF',
  AFFILIATE_ACTIVATED = 'AFFILIATE_ACTIVATED',
  EVENT_ATTRIBUTION_LINKS_STAFF = 'EVENT_ATTRIBUTION_LINKS_STAFF',
  ORDER_CANCELLED_CUSTOMER = 'ORDER_CANCELLED_CUSTOMER',
  CHAT_NEEDS_RESPONSE_MANAGEMENT = 'CHAT_NEEDS_RESPONSE_MANAGEMENT',
  ORDER_CONFIRMATION_CONSUMER = 'ORDER_CONFIRMATION_CONSUMER',
  ORGANIZATION_ACCESS_ADDED_MANAGEMENT = 'ORGANIZATION_ACCESS_ADDED_MANAGEMENT',
  PASSWORD_RESET_CONSUMER = 'PASSWORD_RESET_CONSUMER',
  EMAIL_VERIFICATION_CONSUMER = 'EMAIL_VERIFICATION_CONSUMER',
  CONSUMER_LOGIN_CODE = 'CONSUMER_LOGIN_CODE',
  MANAGEMENT_LOGIN_CODE = 'MANAGEMENT_LOGIN_CODE',
  PASSWORD_RESET_MANAGEMENT = 'PASSWORD_RESET_MANAGEMENT',
  EMAIL_VERIFICATION_MANAGEMENT = 'EMAIL_VERIFICATION_MANAGEMENT',
  USER_INVITED_MANAGEMENT = 'USER_INVITED_MANAGEMENT',
  USER_INVITED_PROMOTER_MANAGEMENT = 'USER_INVITED_PROMOTER_MANAGEMENT',
  USER_INVITED_PARTNER_MANAGEMENT = 'USER_INVITED_PARTNER_MANAGEMENT',
  USER_REGISTERED_CONSUMER = 'USER_REGISTERED_CONSUMER',
  USER_REGISTERED_MANAGEMENT = 'USER_REGISTERED_MANAGEMENT',
  USER_REGISTERED_PROMOTER_MANAGEMENT = 'USER_REGISTERED_PROMOTER_MANAGEMENT',
  USER_REGISTERED_PARTNER_MANAGEMENT = 'USER_REGISTERED_PARTNER_MANAGEMENT',
  SCHEDULED_REPORT_ADMISSION_GROUPS_SUMMARY_VENUE = 'SCHEDULED_REPORT_ADMISSION_GROUPS_SUMMARY_VENUE',
  SCHEDULED_REPORT_UPCOMING_EVENT_TICKET_SUMMARY_VENUE = 'SCHEDULED_REPORT_UPCOMING_EVENT_TICKET_SUMMARY_VENUE',
  SCHEDULED_REPORT_DAY_SUMMARY = 'SCHEDULED_REPORT_DAY_SUMMARY',
  SCHEDULED_REPORT_CSV_EXPORT_MANAGEMENT = 'SCHEDULED_REPORT_CSV_EXPORT_MANAGEMENT',
  DATA_EXPORT_COMPLETED_MANAGEMENT = 'DATA_EXPORT_COMPLETED_MANAGEMENT',
  DATA_EXPORT_FAILED_MANAGEMENT = 'DATA_EXPORT_FAILED_MANAGEMENT',
  NEW_ACCOUNT_SIGNUP_ADMINS = 'NEW_ACCOUNT_SIGNUP_ADMINS',
  NEW_EXTERNAL_PROMOTER_SIGNUP_ADMINS = 'NEW_EXTERNAL_PROMOTER_SIGNUP_ADMINS',
  NEW_EXTERNAL_PROMOTER_ADDED_ADMINS = 'NEW_EXTERNAL_PROMOTER_ADDED_ADMINS',
  NEW_EXTERNAL_PARTNER_SIGNUP_ADMINS = 'NEW_EXTERNAL_PARTNER_SIGNUP_ADMINS',
  NEW_EXTERNAL_PARTNER_ADDED_ADMINS = 'NEW_EXTERNAL_PARTNER_ADDED_ADMINS',
  /** Legacy voided order notice to the guest (consumer). */
  ORDER_VOIDED_CUSTOMER_LEGACY = 'ORDER_VOIDED_CUSTOMER_LEGACY',
  /** New React-based voided order notice to the guest (consumer). */
  ORDER_VOIDED_CUSTOMER = 'ORDER_VOIDED_CUSTOMER',
  /** New React-based refunded order notice to the guest (consumer). */
  ORDER_REFUNDED_CUSTOMER = 'ORDER_REFUNDED_CUSTOMER',
  /** Concierge outbound message to a consumer. */
  CONCIERGE_MESSAGE_USER = 'CONCIERGE_MESSAGE_USER',
  /** Support agent outbound email to a consumer. */
  SUPPORT_AGENT_MESSAGE_USER = 'SUPPORT_AGENT_MESSAGE_USER',
  /** Admin app install link from legacy notify controller. */
  ADMIN_APP_INSTALL_LINK_USER = 'ADMIN_APP_INSTALL_LINK_USER',
  /** Internal staff notice when a new affiliate signs up. */
  AFFILIATE_SIGNUP_INTERNAL = 'AFFILIATE_SIGNUP_INTERNAL',
}
